import ApplicationAdapter from './application';
import { inject as service } from '@ember/service';
import MasqService from 'cio/services/masq';
import AccountService from 'cio/services/account';
import AuthService from 'cio/services/auth';

interface SnippetPayload {
  snippet: Record<string, any>;
  message_item_ids: Record<string, any>[];
  usage_loaded: boolean;
}

interface SnippetsPayload {
  snippets: Record<string, any>[];
  meta: Record<string, any>;
}

export default class SnippetAdapter extends ApplicationAdapter {
  @service account!: AccountService;
  @service masq!: MasqService;
  @service auth!: AuthService;

  handleResponse(
    status: number,
    headers: Record<string, any>,
    payload: SnippetPayload | SnippetsPayload,
    requestData: Record<string, any>,
  ) {
    // Only apply this change to the `findRecord` variant
    if (payload != null && 'snippet' in payload && 'usage_loaded' in payload) {
      payload.snippet.usage_loaded = payload.usage_loaded;
    }

    return super.handleResponse(status, headers, payload, requestData);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    snippet: SnippetAdapter;
  }
}
